/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Icon } from '@trackman/react-ui';
import { History } from 'history';
import Loader from 'components/loader/Loader';
import { CheckIconWrapper, Content, IconAndTextRow, IconWrapper, StyledModal, Text } from './styles/SavingModalStyles';

interface IProps {
  visible: boolean;
  shouldReturn: boolean;
  history: History;
}

export const SavingModal: React.FC<IProps> = ({ visible, shouldReturn, history }) => {
  const [countDown, setCountDown] = useState<number>(5);
  const [step, setStep] = useState<number>(1);
  const intervalRef = useRef<NodeJS.Timeout>();
  useEffect(() => {
    if (visible && shouldReturn) {
      setTimeout(() => {
        setStep(2);
      }, 100);
      if (step === 2) {
        calculateCountdown();
      }
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [visible, step, shouldReturn]);

  useEffect(() => {
    if (countDown === 0 && shouldReturn) {
      document.body.style.overflow = ''; // crappy fix because Modal sets overflow to 'hidden' programatically
      // and then it doesn't have a chance to set it back to ''
      history.push('/');
    }
  }, [countDown]);

  const calculateCountdown = () => {
    let counter = 5;
    intervalRef.current = setInterval(() => {
      counter--;
      setCountDown(counter);
    }, 1000);
  };

  return (
    <StyledModal open={visible} onClose={() => {}} maxWidth='sm' title={step === 1 ? 'Saving Game' : 'Game Saved'} titleCenter>
      <Content>
        <IconAndTextRow>
          <IconWrapper>
            {step === 1 ? (
              <Loader />
            ) : (
              <CheckIconWrapper>
                <Icon name='check' />
              </CheckIconWrapper>
            )}
          </IconWrapper>
          <Text>
            {step === 1
              ? 'This should not take more than a couple of seconds'
              : `Game has been updated. Returning to frontpage in ${countDown}...`}
          </Text>
        </IconAndTextRow>
      </Content>
    </StyledModal>
  );
};
